@if(currentLocale()){
	<ogs-m3-icon icon="calendar"/>
	<time class="mat-body-small">
			{{date() | date:'shortDate' : '' : currentLocale()!.value}}
			{{date() | date:'shortTime' : '' : currentLocale()!.value}}
	</time>
}
